// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"244":"11ae8e76","269":"29965caa","692":"882e15ad"}[chunkId] + ".chunk.css";
};